export default __webpack_public_path__ + "static/media/banner10.52c809f6.jpg";